import { render, staticRenderFns } from "./SelectAuditoresObject.vue?vue&type=template&id=0801aca6"
import script from "./SelectAuditoresObject.vue?vue&type=script&lang=js"
export * from "./SelectAuditoresObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports